import Header from '../../components/feature/Header';
import HeroSection from '../../components/feature/HeroSection';
import BioSection from '../../components/feature/BioSection';
import BookWaitingList from '../../components/feature/BookWaitingList';
import PlatformSection from '../../components/feature/PlatformSection';
import SpeakingSection from '../../components/feature/SpeakingSection';
import VideoSection from '../../components/feature/VideoSection';
import AudioSection from '../../components/feature/AudioSection';
import FAQSection from '../../components/feature/FAQSection';
import QuizSection from '../../components/feature/QuizSection';
import ContactSection from '../../components/feature/ContactSection';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <BioSection />
        <BookWaitingList />
        <PlatformSection />
        <SpeakingSection />
        <VideoSection />
        <AudioSection />
        <QuizSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}
